import mod from "-!./fileDocument.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./fileDocument.js?vue&type=script&lang=js&external"